import { useSelector } from 'react-redux';
import { pipe } from 'fp-ts/function';
import { ord, record } from 'fp-ts';
import { LocalizedText } from '@mews/framework';
import { Stack } from '@optimus-web/core';
import { ApplicationState } from '@mews-commander/types';
import { SummaryRowBody } from '../../SummaryRow';
import { getServiceGroupedReservationStates } from '../../../../../selectors/summary';
import { groupingTextKeyOrd } from '../../../../../selectors';

interface ReservationStateListProps {
    serviceId: string;
    scope: string;
}

const ReservationStateList = ({ scope, serviceId }: ReservationStateListProps) => {
    const reservationStates = useSelector((state: ApplicationState) =>
        getServiceGroupedReservationStates(state, { serviceId, scope })
    );
    return (
        <Stack vertical spacing="100">
            {pipe(
                reservationStates,
                record.collect(groupingTextKeyOrd as ord.Ord<string>)((reservationState, count) => (
                    <SummaryRowBody
                        text={<LocalizedText textKey={reservationState} />}
                        count={count}
                        data-test-service-order-state={reservationState}
                    />
                ))
            )}
        </Stack>
    );
};

export default ReservationStateList;
